const initialState = {
  weatherData: {},
};
export const WeatherReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET__WEATHER__SUCCESS':
      return {
        ...state,
        weatherData: action?.payload || {},
      };
    default:
      return state;
  }
};
